export default {
  selectActivateAcctBtnClicked: (state) => state.activateAcctBtnClicked,
};
